import MainLayout from "../components/layouts/MainLayout";
import Container from "../components/Container";
import SectionFloating from "../components/sections/SectionFloating";
import {generateTitle} from "../helpers/meta";
import Head from "next/head";
import {useRouter} from "next/router";
import localized from "../locale/locales";

export default function Contacts() {
    const {locale} = useRouter();
    const {contacts: lang, common} = localized[locale];

    return (
        <MainLayout>
            <Head>
                <title key="title">{generateTitle(lang.og.title)}</title>
                <meta key="og:title" property="og:title" content={generateTitle(lang.og.title)}/>
            </Head>

            <SectionFloating scheme="contacts"/>

            <Container className="relative mt-[50px] md:mt-0 pt-10 md:pt-44 pb-20 md:pb-32 flex items-start">
                <div
                    className="absolute top-8 right-10 md:flex-1 md:relative md:top-auto md:right-auto flex items-center justify-center">
                    <div className="inline-flex -mr-10">
                        <p className="text-7xl md:text-[183px] leading-none">💬</p>
                        <p className="rotate-[260deg] inline-flex text-7xl md:text-[183px] leading-none relative top-20 right-10">📞</p>
                    </div>
                </div>
                <div className="md:flex-1 flex flex-col gap-16">
                    <section>

                        <header className="mb-6">
                            <h1 className="font-semibold text-xl md:text-4xl">{lang.header.title}</h1>
                        </header>

                        <address className="not-italic leading-[1.8] mb-10"
                                 dangerouslySetInnerHTML={{__html: common.address.join('<br>')}}
                        />

                        <p className="flex flex-col items-start leading-[1.8]">
                            <a href={`tel:${common.phone.split(' ').join('')}`}
                               className="text-purple-800 mouse-hover:underline">{common.phone}</a>
                            <a href={`mailto:${common.email}`}
                               className="text-purple-800 mouse-hover:underline">{common.email}</a>
                        </p>
                    </section>

                    <section>
                        <header className="mb-5">
                            <h2 className="text-0.5xl md:text-2xl font-semibold">{lang.details.title}</h2>
                        </header>
                        <p className="text-sm md:text-base leading-[1.8] max-w-[40ch]">
                            {lang.details.body}
                        </p>
                    </section>
                </div>
            </Container>
        </MainLayout>
    )
}
